import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';
import { QuickSearchProject } from './QuickSearchProject';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type QuickSearchProjectResultFragment = { __typename?: 'ProjectResult', result: { __typename?: 'Project', id: string, name: string, insertedAt: string, private: boolean, archivedAt?: string | null } };

export const QuickSearchProjectResult = /*#__PURE__*/ gql`
    fragment QuickSearchProjectResult on ProjectResult {
  result {
    ...QuickSearchProject
  }
}
    ${QuickSearchProject}` as unknown as DocumentNode<QuickSearchProjectResultFragment, unknown>;

        

        
export const useQuickSearchProjectResultFragment = (
  input: string | Omit<UseFragmentOptions<QuickSearchProjectResultFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'ProjectResult' } };
    return input;
  })();

  return useFragment<QuickSearchProjectResultFragment>({
    fragment: QuickSearchProjectResult,
    fragmentName: 'QuickSearchProjectResult',
    ...options,
  });
};
  
        